import { useState, useEffect } from "react"

const useHandleRequestSnackbar = (messagePopup) => {
    const [snackbarOpen, setSnackbarOpen] = useState(false)
    useEffect(() => {
        if (messagePopup) {
            setSnackbarOpen(true)
        }
    }, [messagePopup])
    const handleSnackbarOpenStatus = (status) => {
        setSnackbarOpen(status)
    }

    return { snackbarOpen, setSnackbarOpen, handleSnackbarOpenStatus }
}

export default useHandleRequestSnackbar
